export type TimeDuration = {
  num: number;
  duration: Duration;
};

export enum Duration {
  Second = "s",
  Minute = "m",
  Hour = "H",
  Day = "D",
  Week = "W",
  Month = "M",
  Year = "Y",
}
